var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsnavbar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_10950",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 3.375C1.625 2.87772 1.82254 2.40081 2.17417 2.04917C2.52581 1.69754 3.00272 1.5 3.5 1.5H18.5C18.9973 1.5 19.4742 1.69754 19.8258 2.04917C20.1775 2.40081 20.375 2.87772 20.375 3.375V26.5H3.5C3.00272 26.5 2.52581 26.3025 2.17417 25.9508C1.82254 25.5992 1.625 25.1223 1.625 24.625V3.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 14C20.375 13.6685 20.5067 13.3505 20.7411 13.1161C20.9755 12.8817 21.2935 12.75 21.625 12.75H24.125C24.4565 12.75 24.7745 12.8817 25.0089 13.1161C25.2433 13.3505 25.375 13.6685 25.375 14V24.625C25.375 25.1223 25.1775 25.5992 24.8258 25.9508C24.4742 26.3025 23.9973 26.5 23.5 26.5H20.375V14Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 6.5H10.375M5.375 10.875H12.875",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_10950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 -1H28.5V29H-1.5V-1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsnavbar);
export default __webpack_public_path__ + "static/media/reports navbar.16a34e4ce1c5bcdcc62caa4af01de3d5.svg";
export { ForwardRef as ReactComponent };